import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Pages.css';

// Import images from src/img
import logo from '../img/logo.png';
import worldMap from '../img/world-map-dark.png';
import sample1 from '../img/1.png';
import sample2 from '../img/2.png';
import sample3 from '../img/6.png';
import slider1 from '../img/1.jpg';
import slider2 from '../img/2.jpg';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [counterValue, setCounterValue] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Function to scroll to top on any navigation
  const handleNavigation = (path) => {
    // Scroll to top instantly
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    // Use requestAnimationFrame to ensure scroll completes before navigation
    requestAnimationFrame(() => {
      // Small delay to ensure scroll is processed
      setTimeout(() => {
        navigate(path);
      }, 50);
    });
  };

  // Scroll to top on component mount (when user visits Home page directly)
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  const slides = [
    {
      image: slider1,
      title: 'Welcome to Info Naukri',
      subtitle: 'Best E-Profile Maker Company',
      description: 'Create professional E-Profiles that stand out and get noticed by top recruiters worldwide.',
      align: 'left',
      buttonText: 'Get Started',
      buttonLink: '/services'
    },
    {
      image: slider2,
      title: 'Info Naukri',
      subtitle: 'Best Interview Team for your career',
      description: 'Make Best Social Profile Pages and land your dream job with our expert career services.',
      align: 'right',
      buttonText: 'Explore Services',
      buttonLink: '/services'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Counter animation
  useEffect(() => {
    const target = 25000;
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    let count = 0;

    const timer = setInterval(() => {
      count++;
      if (count <= steps) {
        current += increment;
        setCounterValue(Math.floor(current));
      } else {
        setCounterValue(target);
        clearInterval(timer);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, []);

  const samples = [
    { id: 1, img: sample1, title: 'Executive Profile', category: 'Corporate' },
    { id: 2, img: sample2, title: 'Creative Portfolio', category: 'Design' },
    { id: 3, img: sample3, title: 'Professional Resume', category: 'Standard' },
  ];

  const features = [
    { icon: 'fa-heart', title: 'Fully Responsive', desc: 'We provide responsive design for E-Profile that works on all devices.' },
    { icon: 'fa-gear', title: 'SEO Friendly', desc: 'We provide SEO friendly environment for E-Profile to maximize visibility.' },
    { icon: 'fa-plug', title: 'Easy Layout', desc: 'On-Line E-Profile make Creative & Easy Layout for better engagement.' },
    { icon: 'fa-shield-alt', title: 'Secure & Private', desc: 'Your data is safe with us. We prioritize your privacy and security.' },
    { icon: 'fa-clock', title: 'Fast Delivery', desc: 'Get your professional E-Profile delivered within 24-48 hours.' },
    { icon: 'fa-star', title: 'Expert Team', desc: 'Our team of experienced professionals ensures the best quality.' },
  ];

  const testimonials = [
    {
      name: 'Rahul Sharma',
      role: 'Software Engineer',
      text: 'Info Naukri helped me create an outstanding E-Profile that landed me my dream job at Google. Their team is truly professional!',
      rating: 5,
      company: 'Google'
    },
    {
      name: 'Priya Patel',
      role: 'Marketing Manager',
      text: 'The Career Services team provided invaluable guidance. My LinkedIn profile has never looked better and I\'m getting more recruiter calls.',
      rating: 5,
      company: 'Amazon'
    },
    {
      name: 'Amit Kumar',
      role: 'Business Analyst',
      text: 'I was struggling with my resume for months. Info Naukri transformed my entire professional profile. Highly recommended!',
      rating: 5,
      company: 'Microsoft'
    }
  ];

  const services = [
    {
      icon: 'fa-file-alt',
      title: 'E-Profile Creation',
      desc: 'Professional E-Profile creation tailored for your career goals.',
      color: '#4ECDC4',
      features: ['Custom Design', 'Mobile Optimized', 'Social Media Integration']
    },
    {
      icon: 'fa-check-circle',
      title: 'Profile Verification',
      desc: 'Verify your education and employment history with our trusted service.',
      color: '#45B7D1',
      features: ['Document Verification', 'Employment Check', 'Education Validation']
    },
    {
      icon: 'fa-hand-holding-heart',
      title: 'Career Assistance',
      desc: 'Get personalized coaching and guidance for your career growth.',
      color: '#96CEB4',
      features: ['Interview Training', 'Resume Review', 'Career Planning']
    },
    {
      icon: 'fa-rocket',
      title: 'Maximize Reach',
      desc: 'Expand your professional reach with our expert optimization services.',
      color: '#FFEAA7',
      features: ['LinkedIn Optimization', 'Network Building', 'Brand Building']
    }
  ];



  const faqs = [
    {
      question: 'What is an E-Profile?',
      answer: 'An E-Profile is your professional online presence that showcases your skills, experience, and achievements. It helps you stand out to recruiters and employers.'
    },
    {
      question: 'How long does it take to create an E-Profile?',
      answer: 'We deliver professional E-Profiles within 24-48 hours, depending on the complexity and customization requirements.'
    },
    {
      question: 'Is my data secure?',
      answer: 'Yes, we prioritize your privacy and security. Your data is encrypted and we never share your personal information with third parties.'
    },
    {
      question: 'Do you offer revisions?',
      answer: 'Yes, we offer unlimited revisions until you are completely satisfied with your E-Profile. Your satisfaction is our top priority.'
    }
  ];

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return React.createElement(
    'main',
    { className: 'home-page' },

    // ===== HERO SLIDER =====
    React.createElement(
      'section',
      { className: 'hero-slider' },
      slides.map((slide, index) =>
        React.createElement(
          'div',
          {
            key: index,
            className: `hero-slide ${index === currentSlide ? 'active' : ''}`,
            style: {
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          },
          React.createElement(
            'div',
            { className: 'container hero-content' },
            React.createElement(
              'div',
              { className: `hero-text ${slide.align === 'right' ? 'text-right' : 'text-left'}` },
              React.createElement(
                'span',
                {
                  className: 'hero-badge',
                  style: {
                    background: 'rgba(255, 255, 255, 0.7)',
                    backdropFilter: 'blur(4px)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#000000'
                  }
                },
                React.createElement('i', { className: 'fas fa-crown', style: { color: '#65d2bc' } }),
                ' Leading Career Platform'
              ),
              React.createElement(
                'h1',
                {
                  style: {
                    color: '#000000',
                    textShadow: '0 2px 30px rgba(255, 255, 255, 0.6)'
                  }
                },
                slide.title
              ),
              React.createElement(
                'h3',
                {
                  style: {
                    color: '#000000',
                    textShadow: '0 2px 20px rgba(255, 255, 255, 0.5)'
                  }
                },
                slide.subtitle
              ),
              React.createElement(
                'p',
                {
                  style: {
                    color: '#1a1a1a',
                    textShadow: '0 2px 20px rgba(255, 255, 255, 0.5)'
                  }
                },
                slide.description
              ),
              React.createElement(
                'div',
                { className: 'hero-buttons' },
                React.createElement(
                  'button',
                  {
                    className: 'btn-primary btn-lg',
                    onClick: () => handleNavigation(slide.buttonLink || '/services')
                  },
                  slide.buttonText || 'Get Started',
                  React.createElement('i', { className: 'fas fa-arrow-right' })
                ),
                React.createElement(
                  'button',
                  {
                    className: 'btn-outline-light',
                    style: {
                      background: 'rgba(255, 255, 255, 0.85)',
                      color: '#000000',
                      border: '2px solid rgba(0, 0, 0, 0.2)'
                    },
                    onClick: () => handleNavigation('/about')
                  },
                  React.createElement('i', { className: 'fas fa-play-circle' }),
                  ' Learn More'
                )
              )
            )
          )
        )
      ),
      React.createElement(
        'button',
        {
          className: 'slider-control prev',
          onClick: () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length),
          'aria-label': 'Previous slide'
        },
        React.createElement('i', { className: 'fas fa-chevron-left' })
      ),
      React.createElement(
        'button',
        {
          className: 'slider-control next',
          onClick: () => setCurrentSlide((prev) => (prev + 1) % slides.length),
          'aria-label': 'Next slide'
        },
        React.createElement('i', { className: 'fas fa-chevron-right' })
      ),
      React.createElement(
        'div',
        { className: 'slider-dots' },
        slides.map((_, index) =>
          React.createElement('button', {
            key: index,
            className: `dot ${index === currentSlide ? 'active' : ''}`,
            onClick: () => goToSlide(index),
            'aria-label': `Go to slide ${index + 1}`
          })
        )
      )
    ),


    // ===== SERVICES SECTION =====
    React.createElement(
      'section',
      { className: 'services-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'section-header' },
          React.createElement('span', { className: 'section-tag' }, 'Our Services'),
          React.createElement('h2', { className: 'section-title' }, 'What We Offer'),
          React.createElement('p', { className: 'section-subtitle' }, 'We provide comprehensive career services to help you succeed')
        ),
        React.createElement(
          'div',
          { className: 'services-grid' },
          services.map((service, index) =>
            React.createElement(
              'div',
              {
                key: index,
                className: 'service-card',
                style: {
                  borderTop: `4px solid ${service.color}`,
                  transform: hoveredService === index ? 'translateY(-8px)' : 'translateY(0)',
                  boxShadow: hoveredService === index ? '0 12px 40px rgba(0,0,0,0.12)' : '0 4px 20px rgba(0,0,0,0.04)',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: () => setHoveredService(index),
                onMouseLeave: () => setHoveredService(null)
              },
              React.createElement(
                'div',
                { className: 'service-icon-wrapper', style: { background: `${service.color}20` } },
                React.createElement('i', { className: `fas ${service.icon}`, style: { color: service.color } })
              ),
              React.createElement('h4', null, service.title),
              React.createElement('p', null, service.desc),
              hoveredService === index && React.createElement(
                'div',
                {
                  className: 'service-features-list',
                  style: {
                    marginTop: '12px',
                    textAlign: 'left',
                    animation: 'fadeInUp 0.3s ease'
                  }
                },
                service.features.map((feature, fIdx) =>
                  React.createElement(
                    'div',
                    {
                      key: fIdx,
                      style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '13px',
                        color: '#475569',
                        marginBottom: '4px'
                      }
                    },
                    React.createElement('i', {
                      className: 'fas fa-check-circle',
                      style: { color: service.color, fontSize: '14px' }
                    }),
                    feature
                  )
                )
              ),
              React.createElement(
                'a',
                {
                  href: '#',
                  className: 'service-link',
                  onClick: (e) => {
                    e.preventDefault();
                    handleNavigation('/services');
                  }
                },
                'Learn More ',
                React.createElement('i', { className: 'fas fa-arrow-right' })
              )
            )
          )
        )
      )
    ),

    // ===== ABOUT SECTION =====
    React.createElement(
      'section',
      { className: 'about-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'about-grid' },
          React.createElement(
            'div',
            { className: 'about-content' },
            React.createElement('span', { className: 'section-tag' }, 'About Us'),
            React.createElement(
              'h2',
              { className: 'section-title' },
              'Your Trusted Career Partner'
            ),
            React.createElement(
              'p',
              null,
              "When you're looking Professional or positioning yourself for career growth, it's important to have an on-line presence where you can showcase your skills and experience. Your on-line profiles will also help you connect with contacts who can expedite your career."
            ),
            React.createElement(
              'p',
              null,
              '"First impression is the last impression". This idiom applies to companies and industries as well. In companies your e-profile is asked before your name and for that, one\'s e-profile must be well designed, well written and should be well maintained too.'
            ),
            React.createElement(
              'div',
              { className: 'about-features' },
              React.createElement(
                'div',
                { className: 'about-feature' },
                React.createElement('i', { className: 'fas fa-check-circle' }),
                React.createElement('span', null, 'Professional E-Profile Design')
              ),
              React.createElement(
                'div',
                { className: 'about-feature' },
                React.createElement('i', { className: 'fas fa-check-circle' }),
                React.createElement('span', null, 'Verified & Trusted Service')
              ),
              React.createElement(
                'div',
                { className: 'about-feature' },
                React.createElement('i', { className: 'fas fa-check-circle' }),
                React.createElement('span', null, '100% Satisfaction Guarantee')
              ),
              React.createElement(
                'div',
                { className: 'about-feature' },
                React.createElement('i', { className: 'fas fa-check-circle' }),
                React.createElement('span', null, '24/7 Customer Support')
              )
            ),
            React.createElement(
              'button',
              {
                className: 'btn-primary',
                onClick: () => handleNavigation('/about')
              },
              'Read More',
              React.createElement('i', { className: 'fas fa-arrow-right' })
            )
          ),
          React.createElement(
            'div',
            { className: 'about-image' },
            React.createElement(
              'div',
              { className: 'about-image-wrapper' },
              React.createElement('img', { src: worldMap, alt: 'Info Naukri' }),
              React.createElement(
                'div',
                { className: 'about-experience' },
                React.createElement('span', null, '10+'),
                React.createElement('small', null, 'Years of Experience')
              )
            )
          )
        )
      )
    ),

    // ===== E-PROFILE SAMPLES SECTION =====
    React.createElement(
      'section',
      { className: 'samples-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'section-header' },
          React.createElement('span', { className: 'section-tag' }, 'Portfolio'),
          React.createElement('h2', { className: 'section-title' }, 'E-Profile Samples'),
          React.createElement('p', { className: 'section-subtitle' }, 'Check out our professionally designed E-Profile samples')
        ),
        React.createElement(
          'div',
          { className: 'samples-grid' },
          samples.map((s, index) =>
            React.createElement(
              'div',
              {
                key: s.id,
                className: 'sample-card',
                onClick: () => handleNavigation(`/service/${s.id}`),
                style: { cursor: 'pointer' }
              },
              React.createElement(
                'div',
                { className: 'sample-image-wrapper' },
                React.createElement('img', { src: s.img, alt: s.title }),
                React.createElement(
                  'div',
                  { className: 'sample-overlay' },
                  React.createElement(
                    'button',
                    { className: 'sample-view-btn' },
                    React.createElement('i', { className: 'fas fa-eye' }),
                    ' View Sample'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'sample-info' },
                React.createElement('h4', null, s.title),
                React.createElement('span', { className: 'sample-category' }, s.category)
              )
            )
          )
        )
      )
    ),

    // ===== AFFILIATE SECTION =====
    React.createElement(
      'section',
      { className: 'affiliate-section', style: { padding: '80px 0', background: '#f8fafc' } },
      React.createElement(
        'div',
        { className: 'container' },
        // Affiliate Header
        React.createElement(
          'div',
          { className: 'affiliate-header', style: { textAlign: 'center', marginBottom: '50px' } },
          React.createElement(
            'span',
            {
              className: 'section-tag', style: {
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                color: 'white',
                padding: '6px 20px',
                borderRadius: '25px',
                display: 'inline-block',
                fontSize: '14px',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }
            },
            'Earn With Us'
          ),
          React.createElement(
            'h2',
            {
              style: {
                fontSize: '38px',
                fontWeight: '700',
                marginTop: '15px',
                marginBottom: '15px',
                color: '#1e293b',
                lineHeight: '1.2'
              }
            },
            'Become an Info Naukri Affiliate'
          ),
          React.createElement(
            'p',
            {
              style: {
                fontSize: '18px',
                color: '#475569',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.7'
              }
            },
            'Join our affiliate program and earn up to 20% commission on every sale. Perfect for content creators, career coaches, and HR professionals who want to monetize their network and help others build their professional presence.'
          )
        ),

        // Affiliate Stats Grid
        React.createElement(
          'div',
          { className: 'affiliate-stats-grid' },
          React.createElement(
            'div',
            {
              style: {
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                padding: '30px 20px',
                borderRadius: '12px',
                textAlign: 'center',
                color: 'white',
                boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)'
              }
            },
            React.createElement('div', { style: { fontSize: '36px', fontWeight: '700' } }, '₹25K+'),
            React.createElement('div', { style: { fontSize: '14px', opacity: '0.9' } }, 'Average Monthly Earnings')
          ),
          React.createElement(
            'div',
            {
              style: {
                background: '#1e293b',
                padding: '30px 20px',
                borderRadius: '12px',
                textAlign: 'center',
                color: 'white',
                boxShadow: '0 4px 15px rgba(30, 41, 59, 0.3)'
              }
            },
            React.createElement('div', { style: { fontSize: '36px', fontWeight: '700' } }, '150+'),
            React.createElement('div', { style: { fontSize: '14px', opacity: '0.9' } }, 'Active Affiliates')
          ),
          React.createElement(
            'div',
            {
              style: {
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                padding: '30px 20px',
                borderRadius: '12px',
                textAlign: 'center',
                color: 'white',
                boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
              }
            },
            React.createElement('div', { style: { fontSize: '36px', fontWeight: '700' } }, '5K+'),
            React.createElement('div', { style: { fontSize: '14px', opacity: '0.9' } }, 'Successful Referrals')
          ),
          React.createElement(
            'div',
            {
              style: {
                background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
                padding: '30px 20px',
                borderRadius: '12px',
                textAlign: 'center',
                color: 'white',
                boxShadow: '0 4px 15px rgba(253, 160, 133, 0.3)'
              }
            },
            React.createElement('div', { style: { fontSize: '36px', fontWeight: '700' } }, '4.8★'),
            React.createElement('div', { style: { fontSize: '14px', opacity: '0.9' } }, 'Affiliate Rating')
          )
        ),

        // Affiliate Content and CTA
        React.createElement(
          'div',
          { className: 'affiliate-content-wrapper' },
          React.createElement(
            'div',
            { className: 'affiliate-features' },
            React.createElement(
              'h3',
              {
                style: {
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#1e293b',
                  marginBottom: '20px'
                }
              },
              'Why Join Info Naukri Affiliate Program?'
            ),
            React.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', gap: '15px' } },
              // Feature 1
              React.createElement(
                'div',
                {
                  style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '15px',
                    padding: '15px',
                    background: 'white',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }
                },
                React.createElement('div', {
                  style: {
                    minWidth: '40px',
                    height: '40px',
                    background: '#65d2bc20',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#65d2bc',
                    fontSize: '18px'
                  }, children: React.createElement('i', { className: 'fas fa-wallet' })
                }),
                React.createElement(
                  'div',
                  null,
                  React.createElement('h4', { style: { fontSize: '16px', fontWeight: '600', margin: '0 0 4px 0' } }, 'High Commission Rates'),
                  React.createElement('p', { style: { fontSize: '14px', color: '#64748b', margin: '0' } }, 'Earn up to 20% commission on every successful referral. The more you refer, the more you earn!')
                )
              ),
              // Feature 2
              React.createElement(
                'div',
                {
                  style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '15px',
                    padding: '15px',
                    background: 'white',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }
                },
                React.createElement('div', {
                  style: {
                    minWidth: '40px',
                    height: '40px',
                    background: '#f093fb20',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#f093fb',
                    fontSize: '18px'
                  }, children: React.createElement('i', { className: 'fas fa-users' })
                }),
                React.createElement(
                  'div',
                  null,
                  React.createElement('h4', { style: { fontSize: '16px', fontWeight: '600', margin: '0 0 4px 0' } }, 'Global Reach'),
                  React.createElement('p', { style: { fontSize: '14px', color: '#64748b', margin: '0' } }, 'Reach a global audience of job seekers and professionals. Your network is your net worth!')
                )
              ),
              // Feature 3
              React.createElement(
                'div',
                {
                  style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '15px',
                    padding: '15px',
                    background: 'white',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }
                },
                React.createElement('div', {
                  style: {
                    minWidth: '40px',
                    height: '40px',
                    background: '#4facfe20',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4facfe',
                    fontSize: '18px'
                  }, children: React.createElement('i', { className: 'fas fa-gift' })
                }),
                React.createElement(
                  'div',
                  null,
                  React.createElement('h4', { style: { fontSize: '16px', fontWeight: '600', margin: '0 0 4px 0' } }, 'Rewards Program'),
                  React.createElement('p', { style: { fontSize: '14px', color: '#64748b', margin: '0' } }, 'Get exclusive rewards, bonuses, and recognition for top-performing affiliates.')
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'affiliate-cta' },
            React.createElement(
              'div',
              { style: { fontSize: '48px', marginBottom: '15px' } },
              React.createElement('i', { className: 'fas fa-hand-holding-usd', style: { color: '#65d2bc' } })
            ),
            React.createElement(
              'h3',
              { style: { fontSize: '22px', fontWeight: '700', color: '#1e293b', marginBottom: '10px' } },
              'Ready to Start Earning?'
            ),
            React.createElement(
              'p',
              { style: { fontSize: '15px', color: '#64748b', marginBottom: '25px' } },
              'Join our affiliate program today and start earning commissions instantly.'
            ),
            React.createElement(
              'button',
              {
                className: 'btn-primary',
                style: {
                  background: 'linear-gradient(135deg, #65d2bc 0%, #4ECDC4 100%)',
                  border: 'none',
                  padding: '14px 35px',
                  fontSize: '16px',
                  fontWeight: '600',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  width: '100%',
                  color: 'white'
                },
                onMouseEnter: (e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(78, 205, 196, 0.4)';
                },
                onMouseLeave: (e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                },
                onClick: () => handleNavigation('/affiliate')
              },
              React.createElement('i', { className: 'fas fa-rocket' }),
              ' Join Affiliate Program'
            ),
            React.createElement(
              'p',
              { style: { fontSize: '13px', color: '#94a3b8', marginTop: '15px' } },
              'No hidden fees. Start earning today!'
            )
          )
        ),

        // How It Works Section
        React.createElement(
          'div',
          { className: 'affiliate-how-it-works', style: { marginTop: '40px' } },
          React.createElement(
            'h3',
            {
              style: {
                fontSize: '28px',
                fontWeight: '700',
                textAlign: 'center',
                color: '#1e293b',
                marginBottom: '40px'
              }
            },
            'How It Works'
          ),
          React.createElement(
            'div',
            { className: 'affiliate-how-it-works-grid' },
            // Step 1
            React.createElement(
              'div',
              {
                style: {
                  textAlign: 'center',
                  padding: '30px 20px',
                  background: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                {
                  style: {
                    width: '70px',
                    height: '70px',
                    background: 'linear-gradient(135deg, #65d2bc 0%, #4ECDC4 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '28px',
                    color: 'white'
                  }
                },
                React.createElement('i', { className: 'fas fa-user-plus' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                '1. Sign Up'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Register for our affiliate program and get your unique referral link.'
              )
            ),
            // Step 2
            React.createElement(
              'div',
              {
                style: {
                  textAlign: 'center',
                  padding: '30px 20px',
                  background: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                {
                  style: {
                    width: '70px',
                    height: '70px',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '28px',
                    color: 'white'
                  }
                },
                React.createElement('i', { className: 'fas fa-share-alt' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                '2. Share & Refer'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Share your referral link with job seekers, friends, and your network.'
              )
            ),
            // Step 3
            React.createElement(
              'div',
              {
                style: {
                  textAlign: 'center',
                  padding: '30px 20px',
                  background: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                {
                  style: {
                    width: '70px',
                    height: '70px',
                    background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '28px',
                    color: 'white'
                  }
                },
                React.createElement('i', { className: 'fas fa-money-bill-wave' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                '3. Earn Rewards'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Earn up to 20% commission for every successful referral that joins Info Naukri.'
              )
            )
          )
        ),

        // Premium Features Section
        React.createElement(
          'div',
          { className: 'affiliate-premium-features', style: { marginTop: '60px' } },
          React.createElement(
            'h3',
            {
              style: {
                fontSize: '28px',
                fontWeight: '700',
                textAlign: 'center',
                color: '#1e293b',
                marginBottom: '15px'
              }
            },
            'Premium Features for Affiliates'
          ),
          React.createElement(
            'p',
            {
              style: {
                fontSize: '16px',
                color: '#64748b',
                textAlign: 'center',
                maxWidth: '600px',
                margin: '0 auto 40px',
                lineHeight: '1.7'
              }
            },
            'Get access to exclusive tools and resources to maximize your earning potential'
          ),
          React.createElement(
            'div',
            { className: 'affiliate-premium-grid' },
            // Feature 1
            React.createElement(
              'div',
              {
                style: {
                  background: 'white',
                  padding: '25px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                { style: { fontSize: '36px', marginBottom: '15px', color: '#65d2bc' } },
                React.createElement('i', { className: 'fas fa-chart-line' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                'Real-Time Analytics'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Track your referrals, clicks, and commissions in real-time with our advanced dashboard.'
              )
            ),
            // Feature 2
            React.createElement(
              'div',
              {
                style: {
                  background: 'white',
                  padding: '25px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                { style: { fontSize: '36px', marginBottom: '15px', color: '#f093fb' } },
                React.createElement('i', { className: 'fas fa-bullhorn' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                'Marketing Materials'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Get access to pre-designed banners, email templates, and social media posts.'
              )
            ),
            // Feature 3
            React.createElement(
              'div',
              {
                style: {
                  background: 'white',
                  padding: '25px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
                }
              },
              React.createElement(
                'div',
                { style: { fontSize: '36px', marginBottom: '15px', color: '#4facfe' } },
                React.createElement('i', { className: 'fas fa-headset' })
              ),
              React.createElement(
                'h4',
                { style: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#1e293b' } },
                'Dedicated Support'
              ),
              React.createElement(
                'p',
                { style: { fontSize: '14px', color: '#64748b', lineHeight: '1.6' } },
                'Get priority support from our affiliate team to help you succeed and grow.'
              )
            )
          )
        )
      )
    ),

    // ===== TESTIMONIALS SECTION =====
    React.createElement(
      'section',
      { className: 'testimonials-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'section-header' },
          React.createElement('span', { className: 'section-tag' }, 'Testimonials'),
          React.createElement('h2', { className: 'section-title' }, 'What Our Clients Say'),
          React.createElement('p', { className: 'section-subtitle' }, 'Real stories from real people who transformed their careers')
        ),
        React.createElement(
          'div',
          { className: 'testimonials-grid' },
          testimonials.map((testimonial, index) =>
            React.createElement(
              'div',
              {
                key: index,
                className: 'testimonial-card'
              },
              React.createElement(
                'div',
                { className: 'testimonial-rating' },
                Array.from({ length: 5 }, (_, i) =>
                  React.createElement('i', {
                    key: i,
                    className: 'fas fa-star',
                    style: { color: i < testimonial.rating ? '#f59e0b' : '#e2e8f0' }
                  })
                )
              ),
              React.createElement('p', { className: 'testimonial-text' }, `"${testimonial.text}"`),
              React.createElement(
                'div',
                { className: 'testimonial-author' },
                React.createElement(
                  'div',
                  { className: 'testimonial-avatar' },
                  testimonial.name.charAt(0)
                ),
                React.createElement(
                  'div',
                  { className: 'testimonial-info' },
                  React.createElement('h4', null, testimonial.name),
                  React.createElement('span', null, testimonial.role),
                  testimonial.company && React.createElement(
                    'span',
                    { style: { color: '#65d2bc', fontSize: '12px', fontWeight: '600' } },
                    ' @ ' + testimonial.company
                  )
                )
              )
            )
          )
        )
      )
    ),

    // ===== FEATURES SECTION =====
    React.createElement(
      'section',
      { className: 'features-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'section-header' },
          React.createElement('span', { className: 'section-tag' }, 'Features'),
          React.createElement('h2', { className: 'section-title' }, 'Why Choose Us'),
          React.createElement('p', { className: 'section-subtitle' }, 'We deliver excellence with every service we provide')
        ),
        React.createElement(
          'div',
          { className: 'features-grid' },
          features.map((feature, index) =>
            React.createElement(
              'div',
              {
                key: index,
                className: 'feature-card',
                style: {
                  transform: hoveredFeature === index ? 'translateY(-8px)' : 'translateY(0)',
                  transition: 'all 0.3s ease'
                },
                onMouseEnter: () => setHoveredFeature(index),
                onMouseLeave: () => setHoveredFeature(null)
              },
              React.createElement(
                'div',
                { className: 'feature-icon-wrapper' },
                React.createElement('i', { className: `fas ${feature.icon}` })
              ),
              React.createElement('h4', null, feature.title),
              React.createElement('p', null, feature.desc)
            )
          )
        )
      )
    ),

    // ===== FAQ SECTION =====
    React.createElement(
      'section',
      { className: 'faq-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'section-header' },
          React.createElement('span', { className: 'section-tag' }, 'FAQ'),
          React.createElement('h2', { className: 'section-title' }, 'Frequently Asked Questions'),
          React.createElement('p', { className: 'section-subtitle' }, 'Find answers to common questions about our services')
        ),
        React.createElement(
          'div',
          { className: 'faq-grid' },
          faqs.map((faq, index) =>
            React.createElement(
              'div',
              {
                key: index,
                className: 'faq-item',
                style: {
                  animation: `fadeInUp ${0.3 + index * 0.1}s ease`
                }
              },
              React.createElement(
                'div',
                { className: 'faq-question' },
                React.createElement('i', { className: 'fas fa-question-circle', style: { color: '#65d2bc' } }),
                React.createElement('h4', null, faq.question)
              ),
              React.createElement('p', { className: 'faq-answer' }, faq.answer)
            )
          )
        )
      )
    ),

    // ===== CTA SECTION =====
    React.createElement(
      'section',
      { className: 'cta-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'cta-content' },
          React.createElement(
            'div',
            { className: 'cta-text' },
            React.createElement('span', { className: 'cta-tag' }, 'Get Started Today'),
            React.createElement('h2', null, 'Ready to Build Your Professional E-Profile?'),
            React.createElement('p', null, 'Join thousands of professionals who have transformed their careers with us.')
          ),
          React.createElement(
            'div',
            { className: 'cta-buttons' },
            React.createElement(
              'button',
              {
                className: 'btn-primary btn-lg',
                onClick: () => handleNavigation('/services')
              },
              'Get Started Now',
              React.createElement('i', { className: 'fas fa-arrow-right' })
            ),
            React.createElement(
              'button',
              {
                className: 'btn-outline-light',
                style: {
                  background: 'rgba(255, 255, 255, 0.9)',
                  color: '#000000',
                  border: '2px solid rgba(255, 255, 255, 0.3)'
                },
                onClick: () => handleNavigation('/contact')
              },
              'Contact Us'
            )
          )
        )
      )
    ),

    // ===== NEWSLETTER SECTION =====
    React.createElement(
      'section',
      { className: 'newsletter-section' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'newsletter-content' },
          React.createElement(
            'div',
            { className: 'newsletter-text' },
            React.createElement(
              'div',
              { className: 'newsletter-icon' },
              React.createElement('i', { className: 'fas fa-envelope-open-text' })
            ),
            React.createElement('h3', null, 'Subscribe to our Newsletter'),
            React.createElement('p', null, 'Stay informed on our latest news and career tips')
          ),
          React.createElement(
            'div',
            { className: 'newsletter-form' },
            React.createElement(
              'div',
              { className: 'input-wrapper' },
              React.createElement('i', { className: 'fas fa-envelope' }),
              React.createElement('input', { type: 'email', placeholder: 'Enter your Email' })
            ),
            React.createElement(
              'button',
              {
                className: 'btn-primary',
                onClick: () => alert('Thank you for subscribing!')
              },
              React.createElement('i', { className: 'fas fa-paper-plane' }),
              ' Subscribe'
            )
          )
        )
      )
    )
  );
};

export default Home;